import { useState } from "react";
import { z } from "zod";

export const useValidation = <T extends z.ZodTypeAny>(
	schema: T,
): [z.inferFlattenedErrors<typeof schema> | undefined, (item: z.infer<typeof schema>) => boolean] => {
	const [errors, setErrors] = useState<z.inferFlattenedErrors<typeof schema>>();

	const onValidate = (item: z.infer<typeof schema>) => {
		const result = schema.safeParse(item);
		if (!result.success) {
			setErrors(result.error.flatten());
			return true;
		}
		setErrors(undefined);
		return false;
	};

	return [errors, onValidate];
};
